const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function normalisePathSegment(segment: string, previousSegment: string | undefined): string {
  // A tenant slug (e.g. `penguin_wealth`) is not a UUID, so without this an invite-data 404
  // would open a separate Sentry issue for every firm rather than one for the endpoint.
  if (previousSegment === 'invite-data') {
    return ':tenant';
  }
  if (UUID_PATTERN.test(segment) || /^\d+$/.test(segment)) {
    return ':id';
  }
  return segment;
}

export function normaliseOperation(operation: string): { method: string; path: string } {
  const firstSpace = operation.indexOf(' ');
  const method = firstSpace === -1 ? 'UNKNOWN' : operation.slice(0, firstSpace);
  const rawPath = firstSpace === -1 ? operation : operation.slice(firstSpace + 1);
  const segments = rawPath.split('?')[0].split('/').filter(Boolean);
  const path = segments
    .map((segment, index) => normalisePathSegment(segment, segments[index - 1]))
    .join('/');
  return { method, path };
}

// Groups Sentry issues by endpoint shape and status instead of by the single capture call site,
// which otherwise collapses every non-2xx response into one issue. Identifier segments are
// normalised so grouping neither over-merges (all endpoints as one) nor over-splits (one issue
// per UUID).
export function apiErrorFingerprint(operation: string, status: number): string[] {
  const { method, path } = normaliseOperation(operation);
  return ['api-error', method, path, String(status)];
}

export function fetchFailureFingerprint(kind: 'timeout' | 'network', operation: string): string[] {
  const { method, path } = normaliseOperation(operation);
  return [`api-${kind}`, method, path];
}
